import qs from 'qs'
import { useCallback, useEffect, useRef } from 'react'
import { useHistory } from 'react-router'
import { useQuery } from './useQuery'

export const useSetQuery = () => {
  const history = useHistory()
  const query = useQuery()
  const queryRef = useRef(query)

  useEffect(() => {
    queryRef.current = query
  }, [query])

  return useCallback(
    (newQuery, overwrite = false) => {
      const search = overwrite ? qs.stringify(newQuery) : qs.stringify({ ...queryRef.current, ...newQuery })
      history.push({ search })
    },
    [history]
  )
}
